import { BaseEntity } from '../../../base/BaseEntity';
import { BaseDocument } from '../../../base/BaseDocument';
import { IBaseEntry } from '../../../base/interfaces/IBaseEntry';
import { InsideType } from './inside-type';

export class Inside extends BaseDocument implements IBaseEntry {    
    plasardInsideTypeId:string;
    plasardInsideType:InsideType;
    picture:string;
    items:InsideItem[];
    locationId:string;
}

export class InsideItem extends BaseEntity implements IBaseEntry {    
    insideId:string;
    itemId:string;
    name:string;
    quantity:number;    
    price:number;
    priceInternal:number;
    amount:number;
    amountInternal:number;
    minDepth:number;
    minWidth:number;
    isDefault:boolean;    
    itemPrice:number;
}